(function(angular) {
    angular.module('wtApp.arrangeTypeInput',
        [
            'ui.router',
            'pascalprecht.translate',
            'ui.bootstrap.datepicker',
            'ui.bootstrap.position',
            'ui.bootstrap.modal',
            'wtApp.wtCommon',
            'wtQueryBuilder',
            'wtApp.dataService'
        ])
        .config(['$translateProvider', function($translateProvider) {
            // define translation url template
            $translateProvider.useLoader('$translatePartialLoader', {
                urlTemplate: 'i18n/{part}/{lang}.json'
            });
            // Use $templateCache
            $translateProvider.useLoaderCache('$templateCache');
            // default language English
            $translateProvider.preferredLanguage('en');
        }]);
})(window.angular);
